module.exports = __webpack_public_path__ + "static/media/ic-next.d4331deb.svg";